/**
 * Ref callback equivalent to React's `autoFocus`, except it asks the
 * browser NOT to scroll the focused element into view. We need this on
 * action buttons inside `.play-overlay-card`, which has `overflow-y: auto`
 * as a clipping safety net — plain `autoFocus` would cause `scrollIntoView`
 * to scroll the card down to the button on short viewports, hiding the
 * title/trophies/stats above it.
 */
export const focusWithoutScroll = (el: HTMLElement | null): void => {
  if (!el) {
    return;
  }
  el.focus({ preventScroll: true });
};
